// Shared look of the SoilSight charts. SVG attributes can't read SCSS variables, so tokens are mirrored here.

/** $green-400: the baseline in every SoilSight chart. */
const BASELINE_GREEN = "#065C45";

export const CHART_GRID_STROKE = "#e8e8e8";
export const CHART_AXIS_COLOR = "#000000";
/** $grey-600: the report's axis labels and the Difference view's baseline. */
export const CHART_MUTED_COLOR = "#6d6d6d";
const CHART_AXIS_FONT_SIZE = 10;
const CHART_REPORT_AXIS_FONT_SIZE = 11;
/** In-plot labels: the Difference view's endpoint total and baseline line. */
export const CHART_LABEL_FONT_SIZE = 11;
/** Y tick labels sit left-aligned at this inset, sharing one left edge with the unit label above. */
export const CHART_Y_TICK_INSET_PX = 8;
/** Fits the widest cumulative CM tick (about six characters with separators) with no spare room beside it. */
export const FORECAST_Y_AXIS_WIDTH_PX = 48;
/** The rem base the outcome chart and table convert measured widths against; the stylesheet's rem values assume it too. */
export const ROOT_FONT_SIZE_PX = 16;

export const CHART_MARGIN = { top: 16, right: 16, left: 8, bottom: 8 };
export const CHART_LINE_WIDTH = 2.5;
export const CHART_ACTIVE_DOT_RADIUS = 5;

export const DIFFERENCE_CHART_HEIGHT = 280;
/** Extra top room for the endpoint total drawn above the last point. */
export const DIFFERENCE_CHART_MARGIN = { ...CHART_MARGIN, top: 28 };
export const DIFFERENCE_GAIN_FILL = "#ebf2f0";
export const DIFFERENCE_LOSS_FILL = "#ffe6df";

export type ChartAxisStyle = { fontSize: number; color: string };

/** Smaller, darker labels on the page; the PDF report keeps larger grey ones. */
export const PAGE_AXIS_STYLE: ChartAxisStyle = { fontSize: CHART_AXIS_FONT_SIZE, color: CHART_AXIS_COLOR };
export const REPORT_AXIS_STYLE: ChartAxisStyle = { fontSize: CHART_REPORT_AXIS_FONT_SIZE, color: CHART_MUTED_COLOR };

type ScenarioLineColor = {
  /** Solid stroke color for the line & legend swatch. */
  line: string;
  /** Semi-transparent area fill used for the confidence band. */
  area: string;
};

/** Per-scenario line/area palette; index 0 is the baseline. Scenarios past the end cycle back to the start. */
export const SCENARIO_LINE_COLORS: ReadonlyArray<ScenarioLineColor> = [
  { line: BASELINE_GREEN, area: "rgba(6, 92, 69, 0.2)" },
  { line: "#E77307", area: "rgba(231, 115, 7, 0.2)" }, // Orange 500
  { line: "#746B9E", area: "rgba(116, 107, 158, 0.2)" }, // Purple 600
  { line: "#64B5F6", area: "rgba(100, 181, 246, 0.2)" }, // Blue 300
  { line: "#4CAF50", area: "rgba(76, 175, 80, 0.2)" }, // Green 500
];

export const FORECAST_CHART_HEIGHT = 240;

/** The baseline's hatched bars: stripes in its line colour over white. */
export const BASELINE_BAR_STRIPE_COLORS = { stripe: BASELINE_GREEN, gap: "#ffffff" };

export const ONBOARDING_CHART_HEIGHT = 320;
export const ONBOARDING_CHART_COLORS = {
  baseline: BASELINE_GREEN,
  change: "#4d85f5", // $blue-500
  band: "rgba(77, 133, 245, 0.15)",
  // $berry-400 at the acquisition chart's delta opacity — a shortfall must not read as a blue gain.
  behindBand: "rgba(154, 92, 122, 0.2)",
  /** The hover cursor and the end-of-forecast marker. */
  guide: "#999",
  dotOutline: "#fff",
};
